export function hideChatWidget() {
  // @ts-ignore
  if (window.Tawk_API.hideWidget) {
    // @ts-ignore
    window.Tawk_API.hideWidget();
  } else {
    // @ts-ignore
    window.Tawk_API.onLoad = function () {
      // @ts-ignore
      window.Tawk_API.hideWidget();
    };
  }
}
